import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";
import { LocationField } from "../../App/Components/Forms/LocationField";
import { LocationValue } from "../../App/Typings/DynamicGroupRules";
import { Grid, TextField } from "@mui/material";
import { useState } from "react";

interface DynamicLocationFieldProps {
  locationValue: LocationValue;
  id: string;
  onChange: (value: LocationValue) => void;
}

export function DynamicLocationField({ locationValue, id, onChange }: DynamicLocationFieldProps) {
  const [locationString, setLocationString] = useState<string>(locationValue.name);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} data-test={`location-container-${id}`}>
          <LocationField
            value={locationString}
            fieldName={id}
            id={id}
            onInputChange={(value) => {
              setLocationString(value);
            }}
            onChange={(val) => {
              if (val) {
                geocodeByAddress(val)
                  .then((results) => getLatLng(results[0]))
                  .then(({ lat, lng }) => {
                    onChange({
                      ...locationValue,
                      latitude: lat,
                      longitude: lng,
                      name: val,
                    });
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={9}>
              <TextField
                id={`location-radius-field-${id}`}
                value={locationValue.radius ?? 0}
                type={"number"}
                onChange={(e) => {
                  onChange({
                    ...locationValue,
                    radius: parseInt(e.target.value ?? 0),
                  });
                }}
              ></TextField>
            </Grid>
            <Grid item xs={3}>
              radius (miles)
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
